import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";

export const CustomToggleOrdersFilter: Handler = props => {
    (props as any).dispatch({
        type: "Custom/OrderHistory/ToggleFiltersOpen",
    });
};

export const chain = [CustomToggleOrdersFilter];

const customToggleFiltersOpen = createHandlerChainRunnerOptionalParameter(chain, {}, "CustomToggleOrdersFilter");
export default customToggleFiltersOpen;
